import { TextField } from "../../../../utils/form";

const NameInput = ({ form: { control } }) => (
  <TextField control={control} fullWidth name="name" label="Nombre" variant="outlined" required />
);

export default NameInput;